"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createApiServerlessFunction_exports = {};
__export(createApiServerlessFunction_exports, {
  createApiServerlessFunction: () => createApiServerlessFunction
});
module.exports = __toCommonJS(createApiServerlessFunction_exports);
var import_path = require("path");
var import_oxc_parser = require("oxc-parser");
var import_magic_string = __toESM(require("magic-string"), 1);
var import_resolve = require("@vxrn/resolve");
var import_fs_extra = __toESM(require("fs-extra"), 1);
var import_fs_extra2 = __toESM(require("fs-extra"), 1);
var import_vc_config_base = require("../config/vc-config-base");
var import_vc_package_base = require("../config/vc-package-base");
var import_getPathFromRoute = require("../getPathFromRoute");
async function createApiServerlessFunction(route, code, oneOptionsRoot, postBuildLogs) {
  var outDir = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "dist";
  try {
    var path = (0, import_getPathFromRoute.getPathFromRoute)(route, {
      includeIndex: true
    });
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] pageName: ${path}`);
    var funcFolder = (0, import_path.join)(oneOptionsRoot, `.vercel/output/functions/${path}.func`);
    await import_fs_extra2.default.ensureDir(funcFolder);
    if (code.includes("react")) {
      postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] detected react in depenency tree for ${path}`);
      var reactPath = (0, import_path.dirname)((0, import_resolve.resolvePath)("react/package.json", oneOptionsRoot));
      await import_fs_extra2.default.copy((0, import_path.resolve)(reactPath), (0, import_path.resolve)((0, import_path.join)(funcFolder, "node_modules", "react")));
    }
    var distAssetsFolder = (0, import_path.resolve)((0, import_path.join)(funcFolder, "assets"));
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] copy shared assets to ${distAssetsFolder}`);
    var sourceAssetsFolder = (0, import_path.resolve)((0, import_path.join)(oneOptionsRoot, outDir, "api", "assets"));
    if (await import_fs_extra.default.pathExists(sourceAssetsFolder)) {
      await import_fs_extra2.default.copy(sourceAssetsFolder, distAssetsFolder);
    }
    await import_fs_extra2.default.ensureDir((0, import_path.resolve)((0, import_path.join)(funcFolder, "entrypoint")));
    var entrypointFilePath = (0, import_path.resolve)((0, import_path.join)(funcFolder, "entrypoint", "index.js"));
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] writing entrypoint to ${entrypointFilePath}`);
    await import_fs_extra2.default.writeFile(entrypointFilePath, wrapHandlerFunctions(code));
    var packageJsonFilePath = (0, import_path.resolve)((0, import_path.join)(funcFolder, "package.json"));
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] writing package.json to ${packageJsonFilePath}`);
    await import_fs_extra2.default.writeJSON(packageJsonFilePath, import_vc_package_base.serverlessVercelPackageJson);
    postBuildLogs.push(`[one.build][vercel.createSsrServerlessFunction] writing .vc-config.json to ${(0, import_path.join)(funcFolder, ".vc-config.json")}`);
    return import_fs_extra2.default.writeJson((0, import_path.join)(funcFolder, ".vc-config.json"), {
      ...import_vc_config_base.serverlessVercelNodeJsConfig,
      handler: "entrypoint/index.js"
    });
  } catch (e) {
    console.error(`[one.build][vercel.createSsrServerlessFunction] failed to generate func for ${route.file}`, e);
  }
}
function wrapHandlerFunctions(code) {
  var parsed;
  try {
    parsed = (0, import_oxc_parser.parseSync)("api.js", code);
  } catch (unused) {
    return code;
  }
  if (!(parsed === null || parsed === void 0 ? void 0 : parsed.program)) return code;
  var functionNamesToHandle = /* @__PURE__ */ new Set([
    "GET",
    "POST",
    "PUT",
    "PATCH",
    "DELETE",
    "HEAD",
    "OPTIONS"
  ]);
  var ms = new import_magic_string.default(code);
  var wrappersToAppend = [];
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = (parsed.program.body || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      var _item_declaration, _fnDecl_id;
      var fnDecl = null;
      var isExported = false;
      var exportNode = null;
      if (item.type === "ExportNamedDeclaration" && ((_item_declaration = item.declaration) === null || _item_declaration === void 0 ? void 0 : _item_declaration.type) === "FunctionDeclaration") {
        fnDecl = item.declaration;
        isExported = true;
        exportNode = item;
      } else if (item.type === "FunctionDeclaration") {
        fnDecl = item;
        isExported = false;
      }
      if (!fnDecl || !((_fnDecl_id = fnDecl.id) === null || _fnDecl_id === void 0 ? void 0 : _fnDecl_id.name) || !functionNamesToHandle.has(fnDecl.id.name)) {
        continue;
      }
      var name = fnDecl.id.name;
      var originalName = `orig_${name}`;
      if (isExported) {
        ms.remove(exportNode.start, fnDecl.start);
      }
      ms.overwrite(fnDecl.id.start, fnDecl.id.end, originalName);
      var exportPrefix = isExported ? "export " : "";
      wrappersToAppend.push(`
${exportPrefix}function ${name}(request) {
  const url = new URL(request.url);
  const params = Object.fromEntries(url.searchParams.entries());
  return ${originalName}(request, { params });
}`);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  if (wrappersToAppend.length > 0) {
    ms.append(wrappersToAppend.join("\n"));
    return ms.toString();
  }
  return code;
}
//# sourceMappingURL=createApiServerlessFunction.js.map
